/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonProposalClosedInfo = {
    PPLID: string;
    EXP: BabylonProposalClosedInfo.EXP;
    TTL: string;
    STAT: BabylonProposalClosedInfo.STAT;
    TPLIST: Array<string>;
    AGE: string;
    ET: number;
};

export namespace BabylonProposalClosedInfo {

    export enum EXP {
        Y = 'Y',
        N = 'N',
    }

    export enum STAT {
        PASSED = 'PASSED',
        REJECTED = 'REJECTED',
        FAILED = 'FAILED',
    }


}

